import * as constants from '../../constants'
import {
  ThemeState,
  FontState,
  DirectionState,
  LocaleState,
  CHANGE_FONT,
  CHANGE_DIRECTION,
  CHANGE_LOCALE,
  CHANGE_THEME,
  CHANGE_LARGE_WINDOW,
  ConfigurationsActionTypes,
  CHANGE_CALENDAR_VIEW
} from "./types"


export function font(state: FontState = constants.configuration.DEFAULT_FONT, action: ConfigurationsActionTypes) {
  switch (action.type) {
    case CHANGE_FONT:
      return action.payload
    default:
      return state
  }
}

export function direction(state: DirectionState = constants.configuration.DEFAULT_DIRECTION, action: ConfigurationsActionTypes) {
  switch (action.type) {
    case CHANGE_DIRECTION:
      return action.payload
    default:
      return state
  }
}
export function locale(state: LocaleState = constants.configuration.DEFAULT_LANGUAGE, action: ConfigurationsActionTypes) {
  switch (action.type) {
    case CHANGE_LOCALE:
      return action.payload
    default:
      return state
  }
}


export function theme(state: ThemeState = constants.configuration.DEFAULT_THEME, action: ConfigurationsActionTypes) {
  if (action.type === CHANGE_THEME) {
    return action.payload;
  }
  return state;
};

export function largeWindow(state: boolean = true, action: ConfigurationsActionTypes) {
  if (action.type === CHANGE_LARGE_WINDOW) {
    return action.payload;
  }
  return state;
};

export function calendarView(state: string = 'day', action: ConfigurationsActionTypes) {
  switch (action.type) {
    case CHANGE_CALENDAR_VIEW:
      return action.payload.data;
    default:
      return state;
  }
};
